/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Category_AddInputs */

const vi_shop_category_add = /** @type {(inputs: Shop_Category_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm danh mục`)
};

/**

* @param {Shop_Category_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_category_add = /** @type {((inputs?: Shop_Category_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Category_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_category_add(inputs)
});